<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="事件名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'eventName',
              {
                rules: [
                  { required: true, message: '请输入事件名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入事件名称"
          />
        </a-form-item>

        <a-form-item
          label="体验金领取方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'goldBuyInFlag',
              { rules: [{ required: true, message: '请选择体验金领取方式' }] },
            ]"
            placeholder="请选择领取方式"
          >
            <a-select-option
              v-for="(item, index) in receiveTypes"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="体验金周期(天)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            @change="getPeriodValue"
            type="number"
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="goldPeriod"
            v-decorator="[
              'goldPeriod',
              {
                rules: [
                  { required: true, message: '请输入体验金周期(交易日)' },
                ],
              },
            ]"
            placeholder="请输入体验金周期(交易日)，111111代表永久体验"
          />
        </a-form-item>
        <a-form-item
          v-if="nextPeriodConfigShow"
          label="下阶段增加体验周期(天)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            min="0"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="goldEndAddPeriod"
            v-decorator="[
              'goldEndAddPeriod',
              {
                rules: [
                  { required: true, message: '请输入增加体验周期(交易日)' },
                ],
              },
            ]"
            placeholder="请输入增加体验周期(交易日)，0代表不增加"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="nextPeriodConfigShow"
          label="体验到期操作"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'goldEndAutoBuyInFlag',
              { rules: [{ required: true, message: '请选择体验到期操作' }] },
            ]"
            placeholder="请选择体验到期操作"
          >
            <a-select-option
              v-for="(item, index) in goldEndOption"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="单只体验金金额(元)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            min="0"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="goldSingleValue"
            v-decorator="[
              'goldSingleValue',
              {
                rules: [
                  { required: true, message: '请输入单只体验金金额(元)' },
                ],
              },
            ]"
            placeholder="请输入单只体验金金额(元)"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="nextPeriodConfigShow"
          label="下阶段增加体验金额(元)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="test"
            min="0"
            :max-length="9"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
            id="goldEndAddValue"
            v-decorator="[
              'goldEndAddValue',
              {
                rules: [{ required: true, message: '请输入增加体验金额(元)' }],
              },
            ]"
            placeholder="请输入增加体验金额(元)，0代表不增加"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="关联体验金产品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="[
              'relevanceGoldProduct',
              { rules: [{ required: true, message: '请选择关联体验金产品' }] },
            ]"
            placeholder="请选择关联体验金产品"
          >
            <a-select-option
              v-for="(item, index) in productList"
              :value="item.productCode"
              :key="index"
              >{{ item.productName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="关联奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="['relevancePrizes']"
            placeholder="请选择关联奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="中奖概率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :default-value="prizeProbability"
            :min="0"
            :max="100"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
            v-model="prizeProbability"
          />
        </a-form-item>

        <!--   涨幅红包使用，暂时注释掉     -->
        <!--<a-form-item label="奖品领取条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag placeholder="请选择奖品领取条件" v-decorator="['prizeEarningsLimit']" :triggerChange="true" dictCode="gold_prize_condition"/>
        </a-form-item>-->

        <a-form-item
          label="奖品领取频率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择奖品领取频率"
            v-decorator="['prizeFrequencyLimit']"
            :triggerChange="true"
            dictCode="prize_week_frequency"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'GoldEventManageModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  data() {
    return {
      prizesList: [], //奖品列表
      productList: [], //产品列表
      nextPeriodConfigShow: false, //体验周期不是永久时配置项显示
      prizeProbability: '',
      receiveTypes: [
        {
          name: '一键领取',
          value: 1,
        },
        {
          name: '自由选择',
          value: 2,
        },
      ],
      goldEndOption: [
        {
          name: '系统自动买入',
          value: 1,
        },
        {
          name: '用户手动领取',
          value: 2,
        },
      ],

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/event/gold/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/event/gold/edit',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.id) {
        this.model.relevancePrizes = this.model.relevancePrizes.split(',');
        this.model.relevanceGoldProduct =
          this.model.relevanceGoldProduct.split(',');
        this.prizeProbability = this.model.prizeProbability; //奖品中奖概率
        if (
          this.model.goldPeriod === '111111' ||
          this.model.goldPeriod === '永久'
        ) {
          this.model.goldPeriod = '111111';
          this.nextPeriodConfigShow = false;
        } else {
          this.nextPeriodConfigShow = true;
        }
      } else {
        this.model.relevancePrizes = [];
        this.model.relevanceGoldProduct = [];
        this.nextPeriodConfigShow = false;
        this.prizeProbability = '100'; //奖品中奖概率,默认100%
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'eventName',
            'goldBuyInFlag',
            'goldPeriod',
            'goldEndAutoBuyInFlag',
            'goldSingleValue',
            'goldEndAddValue',
            'goldEndAddPeriod',
            'relevanceGoldProduct',
            'relevancePrizes',
            'prizeFrequencyLimit',
            'prizeEarningsLimit'
          )
        );
      });

      this.getPrizeList();
      this.getFundList();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.relevancePrizes = formData.relevancePrizes.toString();
          formData.relevanceGoldProduct =
            formData.relevanceGoldProduct.toString();
          formData.prizeProbability = this.prizeProbability;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'eventName',
          'goldBuyInFlag',
          'goldPeriod',
          'goldEndAutoBuyInFlag',
          'goldSingleValue',
          'goldEndAddValue',
          'goldEndAddPeriod',
          'relevanceGoldProduct',
          'relevancePrizes',
          'prizeFrequencyLimit',
          'prizeEarningsLimit'
        )
      );
    },

    /**获取奖品列表*/
    getPrizeList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/market/prize/getPrizeList';
      getAction(getUrl, {}).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
        }
      });
    },

    /**获取产品列表*/
    getFundList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/product/getFundList';
      getAction(getUrl, { status: '1' }).then((res) => {
        if (res.success) {
          this.productList = res.result;
        }
      });
    },

    receiveTypesValue(e) {},

    getPeriodValue(value) {
      if (value.target.value !== '111111') {
        //体验金周期不是永久，需要展示
        this.nextPeriodConfigShow = true;
      } else {
        this.nextPeriodConfigShow = false;
      }
    },
  },
};
</script>
